{
  "title": "Participants Table Column Reference",
  "description": "Column definitions and available filters on the Participants page, for quick lookup.",
  "headings": ["Column Reference", "Available Filters"],
  "intro": "The Participants page (under the \"Data\" nav group) is a competition-wide table of actual participants only (team leaders and members) — deliberately separate from the \"Members & Roles\" page, which manages staff, admin, and judge governance roles. The two pages have different data sources and purposes; don't confuse them.",
  "submissionSectionHeading": "Column Reference",
  "submissionStatuses": [
    {
      "name": "Name / Email",
      "editable": "The participant's display name and registered email, shown together in one column."
    },
    { "name": "Team", "editable": "The name of the team this participant belongs to." },
    {
      "name": "Team Role",
      "editable": "The participant's role within the team — Leader or Member."
    },
    {
      "name": "Category",
      "editable": "The competition category the participant's team registered under."
    },
    {
      "name": "School",
      "editable": "The school the participant entered; shows \"Not set\" if left blank."
    },
    {
      "name": "Department",
      "editable": "The department the participant entered; shows \"Not set\" if left blank."
    },
    {
      "name": "Eligibility Status",
      "editable": "The exact same status badge as the Eligibility tab on Members & Roles (Verified / Pending / Rejected / Missing / Expired)."
    },
    {
      "name": "Registration Status",
      "editable": "Whether this participant's registration form is Complete or Incomplete — a determination that is entirely independent of eligibility status."
    },
    { "name": "Last Updated", "editable": "The last time this participant record changed." }
  ],
  "judgeSectionHeading": "Available Filters",
  "judgeStatuses": [
    {
      "name": "Filter by team",
      "description": "Pick a specific team from the dropdown to show only its participants."
    },
    {
      "name": "Filter by category",
      "description": "Show only participants in a given competition category."
    },
    {
      "name": "Filter by eligibility status",
      "description": "Show only participants with a given eligibility status."
    },
    {
      "name": "Filter by registration status",
      "description": "Show only participants whose registration is Complete or Incomplete."
    },
    {
      "name": "Search by name / email / school",
      "description": "A text search box that matches across name, email, and school at once."
    },
    {
      "name": "Sort",
      "description": "Sort the list by name or by last-updated time; every filter and sort choice is kept in the URL, so sharing the link or reloading the page preserves your query."
    }
  ]
}
